import React, { useCallback, useEffect, useState } from "react";

import DashboardGreeting from "../DashboardGreeting";

import SearchIcon from "../../assets/images/search.svg";
import Delete from "../common/CustomModals/Delete";

import FilterIcon from "../../assets/images/filter.svg";
import ExportIcon from "../../assets/images/export.svg";

import moment from "moment";

import Select from "react-select";

import dayjs from "dayjs";

import ExcelJS from "exceljs";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { useStateContext } from "../../contexts/ContextProvider";

import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import "./table.css";
import DashboardService from "../../services/dashboard.service";
import ReportsFilterModal from "../common/ReportsFilterModal";
import MonthlyLeavesReport from "./MonthlyLeavesReport";
import QuarterlyLeavesReport from "./QuarterlyLeavesReport";
import DataTableComponent from "../Charts/DatatableComponent";
import LeaveOverviewReport from "./LeaveOverviewReport";
import CommonService from "../../services/common.service";

import DataTable from "react-data-table-component";
import { se } from "date-fns/locale";
import { Empty, Skeleton } from "antd";

const Reports = ({ user }) => {
  const navHeading = "Reports";

  const { locations, filterBy, setFilterBy } = useStateContext();

  const [selectedQuarter, setSelectedQuarter] = useState(null);

  const currentYear = new Date().getFullYear();

  const [year, setYear] = useState(currentYear);

  const lists = [
    { name: "Q1", code: "1" },
    { name: "Q2", code: "2" },
    { name: "Q3", code: "3" },
    { name: "Q4", code: "4" },
  ];

  const [checked, setChecked] = useState([]);
  const [checkedQuarters, setCheckedQuarters] = useState([]);
  const [checked2, setChecked2] = useState([
    "Paid",
    "Goodwill",
    "Unpaid",
    "LOP/Late Mark",
    "Total Absent Days",
  ]);
  const [checkedCols, setCheckedCols] = useState(checked2);

  const getQuarterFromCurrentDate = () => {
    const month = new Date().getMonth() + 1; // getMonth() returns 0–11
    const quarter = Math.ceil(month / 3);
    const selectedQuarter = lists.filter(
      (item) => item.code === quarter.toString(),
    );
    setSelectedQuarter(selectedQuarter[0]);
    setChecked([`Q${quarter.toString()}`]);
    setCheckedQuarters([`Q${quarter.toString()}`]);
  };

  useEffect(() => {
    getQuarterFromCurrentDate();
  }, []);

  const reportTypes = [
    {
      value: "1",
      label: "Quarterly",
    },
    {
      value: "2",
      label: "Monthly",
    },
  ];

  const initialData = {
    location: "Pune",
    fromDate: "",
    formatedFromDate: "",
    toDate: "",
    formatedToDate: "",
    empId: "",
  };

  const [details, setDetails] = useState(initialData);

  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();

  const [tabIndex, setTabIndex] = useState(0);

  const [search, setSearch] = useState("");

  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);



  const [filter2, setFilter2] = useState(false);
  const [filteredData2, setFilteredData2] = useState([]);

  const [date, setDate] = useState(new Date());

  const [showDelete, setShowDelete] = useState(false);

  const [quarterlyLeavesReport, setQuarterlyLeavesReport] = useState([]);
  const [monthlyLeavesReport, setMonthlyLeavesReport] = useState([]);

  const [quarterlyLeavesReportFilter, setQuarterlyLeavesReportFilter] = useState(false);
  const [quarterlyLeavesReportFilterData, setQuarterlyLeavesReportFilterData] = useState(false);

  const [monthlyLeavesReportFilter, setMonthlyLeavesReportFilter] = useState(false);
  const [monthlyLeavesReportFilterData, setMonthlyLeavesReportFilterData] = useState(false);

  const [loading, setLoading] = useState(false);

  const [loading2, setLoading2] = useState(false);

  const [leaveOverviewData, setLeaveOverviewData] = useState([]);

  const [selectedReportType, setSelectedReportType] = useState({
    value: "1",
    label: "Quarterly",
  });

  const secondsToMMSS = (totalSeconds) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0",
    )}`;
  };

  const columns = [
    {
      name: "Att. Date",
      selector: (row) => row.logdate,
      cell: (row) => (
        <>
          <span>{row.logdate && row.logdate.split(" ")[0]}</span>
        </>
      ),
      width: "110px",
    },
    {
      name: "In Time",
      selector: (row) => row.inTime,
      width: "90px",
    },
    {
      name: "Out Time",
      selector: (row) => row.outTime,
      width: "90px",
    },
    {
      name: "Shift",
      selector: (row) => row.shift,
      width: "60px",
    },
    {
      name: "sInTime",
      selector: (row) => row.sInTime,
      width: "85px",
    },
    {
      name: "sOutTime",
      selector: (row) => row.sOutTime,
      width: "90px",
    },
    {
      name: "Work Duration",
      selector: (row) => row.workDuration,
      width: "90px",
    },
    {
      name: "OT",
      selector: (row) => row.ot,
      width: "90px",
    },
    {
      name: "Total Duration",
      selector: (row) => row.totalWorkingHourse,
      width: "90px",
    },
    {
      name: "Late By",
      selector: (row) => row.lateBy,
      cell: (row) => <>{secondsToMMSS(row.lateBy)}</>,
      width: "90px",
    },
    {
      name: "Early Going By",
      selector: (row) => row.earlyGoingBy,
      cell: (row) => <>{secondsToMMSS(row.earlyGoingBy)}</>,
      width: "90px",
    },
    {
      name: "Location",
      selector: (row) => row.location,
      width: "150px",
    },
    {
      name: "Platform",
      selector: (row) => row.platform,
      cell: (row) => (
        <>
          <div
            className={
              row.platform === "1"
                ? "status elms"
                : row.platform === "2"
                  ? "status attendrix"
                  : "status"
            }
          >
            <span>
              {row.platform === "1"
                ? "eSSL"
                : row.platform === "2"
                  ? "Attendrix"
                  : "-"}
            </span>
          </div>
        </>
      ),
      width: "100px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row) => (
        <>
          <div
            className={`${
              row.lateMarkSts === 0 && row.pstatus === "Present"
                ? "status present"
                : row.lateMarkSts === 1
                  ? "status latemark"
                  : row.pstatus === "Holiday"
                    ? "status halfDay"
                    : row.pstatus === "Absent" && row.holidaysts === 0
                      ? "status absent"
                      : row.holidaysts === "Weekoff" || row.holidaysts === "1"
                        ? "status"
                        : "status"
            }`}
          >
            {row.lateMarkSts === 0 && row.pstatus === "Present" ? (
              <>
                <span title={row.pstatus}>{row.pstatus}</span>
              </>
            ) : row.lateMarkSts === 1 ? (
              <span title="Late Mark">Late Mark</span>
            ) : row.holidaysts === "Weekoff" || row.holidaysts === 1 ? (
              <>
                <span title="Week Off">Week Off</span>
              </>
            ) : (
              <>
                <span title={row.pstatus}>{row.pstatus}</span>
              </>
            )}
          </div>
        </>
      ),
      width: "100px",
    },
    {
      name: "Punch Records",
      selector: (row) => row.punchRecord,
      width: "700px",
    },
  ];

  const fetchQutrlyLeaveReport = (year) => {
    const paylaod = {
      year: year.toString(),
    };

    setLoading(true);

    DashboardService.getQutrlyLeaveReport(paylaod)
      .then((resp) => {
        if (resp.data) {
          setLoading(false);
          setQuarterlyLeavesReport(resp.data);
          const data = resp.data.filter((item) => item.location === "Pune");
          setQuarterlyLeavesReportFilter(true);
          setQuarterlyLeavesReportFilterData(data);
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    fetchQutrlyLeaveReport(year);
  }, []);

  const fetchMonthlyLeaveReport = (payload) => {
    setLoading(true);
    DashboardService.getMonthlyLeaveReport(payload)
      .then((resp) => {
        if (resp.data) {
          setLoading(false);
          setMonthlyLeavesReport(resp.data);
          const data = resp.data.filter((item) => item.location === "Pune");
          setMonthlyLeavesReportFilter(true);
          setMonthlyLeavesReportFilterData(data);
        }
      })
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    if (selectedReportType.value === "2") {
      const payload = {
        fromdate: dayjs(date).startOf("month").format("YYYY-MM-DD"),
        todate: dayjs(date).endOf("month").format("YYYY-MM-DD"),
      };

      fetchMonthlyLeaveReport(payload);
    } else {
      fetchQutrlyLeaveReport(year);
    }
  }, [selectedReportType, date]);

  function minutesToHHSS(minutes) {
    const hrs = Math.floor(minutes / 60);
    const mins = Math.floor(minutes % 60);
    const formattedHrs = String(hrs).padStart(2, "0");
    const formattedMins = String(mins).padStart(2, "0");
    return `${formattedHrs}:${formattedMins}`;
  }

  const handleSelectChange = (e) => {
    setSelectedReportType(e);
  };

  const [attendeces, setAttendeces] = useState([]);

  const timeToSeconds = (time) => {
    const [h, m, s] = time.split(":").map(Number);
    return h * 3600 + m * 60 + s;
  };

  const secondsToTime = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    return [
      String(h).padStart(2, "0"),
      String(m).padStart(2, "0"),
      String(s).padStart(2, "0"),
    ].join(":");
  };

  const fetchDailyAttendeceReport = (payload) => {
    setLoading2(true);
    DashboardService.getDailyAttendeceReport(payload)
      .then((resp) => {
        if (resp.data) {
          const updatedData = resp.data.map((item) => ({
            ...item,
            // presentDays: item.attendenceDays.filter((day) => day.pstatus === "Present").length,
            holidaystsCount: item.attendenceDays.filter(
              (day) => day.pstatus === "Holiday",
            ).length,
            weekoffCount: item.attendenceDays.filter(
              (day) => day.holidaysts === 1,
            ).length,
            absentDaysCount: item.attendenceDays.filter(
              (day) => day.pstatus === "Absent" && day.holidaysts === 0,
            ).length,
            totalDur: secondsToTime(
              item.attendenceDays.reduce((sum, day) => {
                return (
                  sum + timeToSeconds(day.totalWorkingHourse || "00:00:00")
                );
              }, 0),
            ),
            attendenceDays: item.attendenceDays.map((item2) => ({
              ...item2,
              platform: item.platfrom,
            })),
          }));

          setLoading2(false);

          setAttendeces(updatedData);
          // console.log("updatedData", updatedData);
          if (details.location === "all") {
            setFilteredData2(updatedData);
          } else {
            const data = updatedData.filter(
              (item) => item.location === details.location,
            );
            setFilter2(true);
            setFilteredData2(data);
          }
        }
      })
      .catch((e) => console.log(e));
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    const keyword = e.target.value.toLowerCase();

    if (tabIndex === 0) {
      if (keyword.length > 0) {
        setFilter(true);
      } else {
        setFilter(false);
      }

      const data =
        selectedReportType.value === "1" ? quarterlyLeavesReport : monthlyLeavesReport;
      const filteredData = data.filter(
        (row) =>
          (row.employeeId && row.employeeId.toLowerCase().includes(keyword)) ||
          (row.empName && row.empName.toLowerCase().includes(keyword)),
      );

      setFilteredData(filteredData);
    } else if (tabIndex === 2) {
      if (keyword.length > 0) {
        setFilter(true);
      } else {
        setFilter(false);
      }

      const filteredData = leaveOverviewData.filter(
        (row) =>
          (row.empCode && row.empCode.toLowerCase().includes(keyword)) ||
          (row.empName && row.empName.toLowerCase().includes(keyword)),
      );
      setFilteredData(filteredData);
    } else if (tabIndex === 1) {
      const data = filter2 ? filteredData2 : attendeces;
      if (keyword.length > 0) {
        setFilter2(true);
      } else {
        const month = moment(new Date(details.fromDate)).format("M");
        const year = moment(new Date(details.fromDate)).format("YYYY");

        const payload = {
          empid: "string",
          fromdate: details.fromDate,
          todate: details.toDate,
          month: month,
          year: year,
        };

        fetchDailyAttendeceReport(payload);

        //  setFilter2(false);
      }

      const filteredData = data.filter(
        (row) =>
          (row.empCode && row.empCode.toLowerCase().includes(keyword)) ||
          (row.empName && row.empName.toLowerCase().includes(keyword)),
      );

      setFilteredData2(filteredData);
    }
  };

  const fetchDailyAttendeceReportCurrentMonth = useCallback(() => {
    const date = new Date();
    const fromDate = moment(date).startOf("month").format("YYYY-MM-DD");
    const month = moment(new Date(date)).format("M");
    const year = moment(new Date(date)).format("YYYY");
    const currentMonth = moment().format("M");
    let toDate;

    if (month === currentMonth) {
      // If selected month is current month → current date
      toDate = moment().format("YYYY-MM-DD");
    } else {
      // Else → end of the selected month
      toDate = moment(date).endOf("month").format("YYYY-MM-DD");
    }

    setDetails((prev) => ({
      ...prev,
      fromDate: fromDate,
      toDate: toDate,
    }));

    const payload = {
      empid: "string",
      fromdate: fromDate,
      todate: toDate,
      month: month,
      year: year,
    };

    if (tabIndex === 1) {
      fetchDailyAttendeceReport(payload);
    }
  }, [tabIndex]);

  useEffect(() => {
    fetchDailyAttendeceReportCurrentMonth();
  }, [fetchDailyAttendeceReportCurrentMonth]);

  const handleDateChange = (e) => {
    setDate(e.value);
    const fromDate = moment(e.value).startOf("month").format("YYYY-MM-DD");
    const month = moment(new Date(e.value)).format("M");
    const year = moment(new Date(e.value)).format("YYYY");
    const currentMonth = moment().format("M");
    let toDate;

    if (month === currentMonth) {
      // If selected month is current month → current date
      toDate = moment().format("YYYY-MM-DD");
    } else {
      // Else → end of the selected month
      toDate = moment(e.value).endOf("month").format("YYYY-MM-DD");
    }

    const payload = {
      empid: "string",
      fromdate: fromDate,
      todate: toDate,
      month: month,
      year: year,
    };

    if (tabIndex === 1) {
      fetchDailyAttendeceReport(payload);
      setDetails((prevState) => ({
        ...prevState,
        month: month,
        year: year,
        formDate: fromDate,
        toDate: toDate,
      }));
    } else if (tabIndex === 2) {
      const payload = {
        empid: details.empId ? details.empId : null,
        fromdate: fromDate,
        todate: toDate,
      };

      setDetails((prev) => ({
        ...prev,
        fromDate: fromDate,
        toDate: toDate,
      }));

      setLoading(true);

      CommonService.getLeaveOverViewReport(payload)
        .then((resp) => {
          if (resp.data) {
            setLoading(false);
            setLeaveOverviewData(resp.data);
          }
        })
        .catch((e) => console.log(e));
    } else {
      setDetails(initialData);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetails({ ...details, [name]: value });
  };

  const showFilter = (e) => {
    e.preventDefault();
    setFilterBy(true);
  };

  const handleCheckedChange = (type) => (e) => {
    if (e.target.checked) {
      setChecked((prev) => [...prev, type]);
    } else {
      setChecked((prev) => prev.filter((item) => item !== type));
    }
  };

  const handleCheckedChange2 = (type, index) => (e) => {
    setChecked2((prev) => {
      const updated = [...prev];

      if (e.target.checked) {
        updated[index] = type; // restore at same index
      } else {
        updated[index] = null; // remove but keep index
      }

      return updated;
    });
  };

  const handleFilter = () => {
    console.log("tabIndex", tabIndex);
    console.log("details", details, user.role);
    if (tabIndex === 1) {
      if (
        user.role === "1" &&
        details.fromDate !== "" &&
        details.toDate !== ""
      ) {
        const month = moment(new Date(details.fromDate)).format("M");
        const year = moment(new Date(details.fromDate)).format("YYYY");
        console.log("abcd");

        const payload = {
          empid: "string",
          fromdate: details.fromDate,
          todate: details.toDate,
          month: month,
          year: year,
        };
        // console.log(payload);
        fetchDailyAttendeceReport(payload);
      }

      if (details.location !== "") {
        let filteredData = attendeces;

        const objectValues = {
          location: details.location,
        };

        const nonEmptyDetails = Object.fromEntries(
          Object.entries(objectValues).filter(
            ([_, value]) => value !== "" && value !== null,
          ),
        );

        filteredData = filteredData.filter((item) =>
          Object.entries(nonEmptyDetails).every(
            ([detailsKey, value]) => item[detailsKey] === value,
          ),
        );

        // console.log("attendeces", attendeces);

        // console.log("filteredData", filteredData);

        setFilter2(true);

        if (details.location === "all") {
          setFilteredData2(attendeces);
        } else {
          setFilteredData2(filteredData);
        }
      }

    } else if (tabIndex === 2) {
      if (
        details.empId !== "" ||
        details.fromDate !== "" ||
        details.toDate !== ""
      ) {
        const payload = {
          empid: details.empId ? details.empId : null,
          fromdate: details.fromDate,
          todate: details.toDate,
        };

        setLoading(true);

        CommonService.getLeaveOverViewReport(payload)
          .then((resp) => {
            if (resp.data) {
              setLoading(false);
              setLeaveOverviewData(resp.data);
              setFilter(false);
            }
          })
          .catch((e) => console.log(e));
      }
    } else {
      if (
        user.role === "1" &&
        details.fromDate !== "" &&
        details.toDate !== ""
      ) {
        const payload = {
          fromdate: details.fromDate,
          todate: details.toDate,
        };
        fetchMonthlyLeaveReport(payload);
      }

      fetchQutrlyLeaveReport(year);

      let filteredData = quarterlyLeavesReport;

      setCheckedQuarters(checked);
      setCheckedCols(checked2);

      const objectValues = {
        location: details.location,
      };

      const nonEmptyDetails = Object.fromEntries(
        Object.entries(objectValues).filter(
          ([_, value]) => value !== "" && value !== null,
        ),
      );

      filteredData = filteredData.filter((item) =>
        Object.entries(nonEmptyDetails).every(
          ([detailsKey, value]) => item[detailsKey] === value,
        ),
      );

      // console.log("filteredData new", filteredData);

      setQuarterlyLeavesReportFilter(true);
      setQuarterlyLeavesReportFilterData(filteredData);
    }

    setFilterBy(false);
  };

  const clearFilter = () => {
    // console.log("123", details);
    // setFilter(false);
    fetchQutrlyLeaveReport(year);
    fetchDailyAttendeceReportCurrentMonth();
    setSearch("");
    setFilterBy(false);
    // setDetails(initialData);
    setToDate("");
    setFromDate("");
    setDate(new Date());
  };

  const exportToExcel = () => {
    const table = document.getElementById("myTable");

    // Convert HTML table to worksheet
    const workbook = XLSX.utils.table_to_book(table, { sheet: "Sheet1" });

    // Create Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save file
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(data, "Leaves_Report.xlsx");
  };

  const exportAttendanceReport = async () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Attendance");

    const data = filter2 ? filteredData2 : attendeces;

    sheet.views = [
      {
        state: "frozen",
        xSplit: 0,
        ySplit: 5,
      },
    ];

    /* ===== TITLE ===== */
    sheet.mergeCells("B2:L2");
    sheet.getCell("B2").value =
      "Daily Attendance Report (Detailed Summary Report)";
    sheet.getCell("B2").font = { bold: true, size: 14 };
    sheet.getCell("B2").alignment = { horizontal: "center" };

    /* ===== DATE RANGE ===== */
    sheet.mergeCells("B4:L4");
    sheet.getCell("B4").value = `${moment(details.fromDate).format(
      "MMM DD YYYY",
    )}  To  ${moment(details.toDate).format("MMM DD YYYY")}`;
    sheet.getCell("B4").alignment = { horizontal: "center" };

    /* ===== COMPANY INFO ===== */
    sheet.getCell("B5").value = "Company:";
    sheet.getCell("B5").font = { bold: true };
    sheet.getCell("C5").value = "AS";

    const startCol = 1; // A
    const endCol = 23; // W

    for (let col = startCol; col <= endCol; col++) {
      sheet.getCell(5, col).border = {
        bottom: { style: "medium", color: { argb: "FF000000" } },
      };
    }

    let currentRow = 8;

    data.forEach((emp, empIndex) => {
      /* ===== EMPLOYEE INFO ===== */

      sheet.getCell(`B${currentRow}`).value = "Emp Code:";
      sheet.getCell(`C${currentRow}`).value = emp.empCode;

      sheet.getCell(`B${currentRow}`).font = { bold: true };

      sheet.getCell(`E${currentRow}`).value = "Employee Name:";
      sheet.getCell(`G${currentRow}`).value = emp.empName;

      sheet.getCell(`E${currentRow}`).font = { bold: true };

      sheet.mergeCells(`E${currentRow}:F${currentRow}`);

      currentRow++;

      // currentRow += 2;

      /* ===== TABLE HEADER ===== */
      const headerRow = sheet.addRow([
        "",
        "Att. Date",
        "In Time",
        "Out Time",
        "Shift",
        "S. InTime",
        "S. OutTime",
        "Work Dur.",
        "OT",
        "Tot. Dur.",
        "Late By",
        "Early Going By",
        "Location",
        "Platform",
        "Status",
        "Punch Records",
      ]);

      sheet.mergeCells(`P${headerRow.number}:W${headerRow.number}`);

      headerRow.eachCell((cell, colNumber) => {
        if (colNumber === 1) return; // Skip column A

        cell.font = { bold: true };
        cell.alignment = { horizontal: "left" };
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      });

      /* ===== ATTENDANCE ROWS ===== */
      emp.attendenceDays.forEach((day) => {
        const status =
          day.lateMarkSts === 0 && day.pstatus === "Present"
            ? day.pstatus
            : day.lateMarkSts === 1
              ? "Late Mark"
              : day.holidaysts === "Weekoff" || day.holidaysts === 1
                ? "Week Off"
                : day.pstatus;
        const platform =
          day.platform === "1"
            ? "eSSL"
            : day.platform === "2"
              ? "Attendrix"
              : "-";
        const row = sheet.addRow([
          "",
          moment(day.logdate, "DD-MM-YYYY HH:mm:ss").format("DD-MMM-YYYY") ||
            "",
          day.inTime || "",
          day.outTime || "",
          day.shift || "",
          day.sInTime || "",
          day.sOutTime || "",
          day.workDuration || "",
          day.ot || "",
          day.totalWorkingHourse || "",
          secondsToMMSS(day.lateBy) || "",
          secondsToMMSS(day.earlyGoingBy) || "",
          day.location || "",
          platform || "",
          status || "",
          day.punchRecord || "",
        ]);

        sheet.mergeCells(`P${row.number}:W${row.number}`);

        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
        });

        sheet.getCell(`N${row.number}`).alignment = {
          horizontal: "left",
          vertical: "middle",
        };
      });

      const lastRowNumber = sheet.lastRow.number + 1;

      sheet.mergeCells(`B${lastRowNumber}:W${lastRowNumber}`);
      sheet.getCell(`B${lastRowNumber}`).value =
        `Total Duration=${emp.totalDur} , PresentDays=${emp.presentDays} , Leaves=${emp.leaveDays} , Holiday=${emp.holidaystsCount} , AbsentDays=${emp.absentDaysCount} , Weekly Off =${emp.weekoffCount}`;
      sheet.getCell(`B${lastRowNumber}`).font = { bold: true };

      /* ===== SPACE BETWEEN EMPLOYEES ===== */
      currentRow = sheet.lastRow.number + 2;
    });

    /* ===== COLUMN WIDTH ===== */
    sheet.columns = [
      { width: 2 },
      { width: 12 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
      { width: 12 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
      { width: 14 },
      { width: 12 },
      { width: 12 },
    ];

    const START_COL = 1; // A
    const END_COL = 23; // W

    const statusCol = 15;
    const platformCol = 14;

    sheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      for (let col = START_COL; col <= END_COL; col++) {
        const cell = row.getCell(col); // <-- forces cell creation

        const statusCell = row.getCell(statusCol);
        const platformCell = row.getCell(platformCol);

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFFFF" }, // white
        };

        if (statusCell.value === "Present") {
          statusCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "c2f2dc" }, // Green
          };
        }

        if (statusCell.value === "Holiday") {
          statusCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "fff5c7" }, // Yellow
          };
        }

        if (statusCell.value === "Late Mark") {
          statusCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "fed2c8" }, // Yellow
          };
        }

        if (statusCell.value === "Absent" || statusCell.value === "OnLeave") {
          statusCell.font = { bold: true };
          statusCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "fb6240" }, // Red
          };
        }

        if (statusCell.value === "Week Off") {
          statusCell.font = { bold: true };
        }

        if (platformCell.value === "eSSL") {
          platformCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "fed2c8" }, // Red
          };
        }

        if (platformCell.value === "Attendrix") {
          platformCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFADD8E6" }, // blue
          };
        }

        // Optional: clear borders if needed
        // cell.border = {};
      }
    });

    sheet.views = [{ showGridLines: false }];

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      "Daily_Attendance_Report.xlsx",
    );
  };

  const exportLeaveOverviewReport = async () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Attendance");

    const data = leaveOverviewData;

    sheet.views = [
      {
        state: "frozen",
        xSplit: 0,
        ySplit: 5,
      },
    ];

    /* ===== TITLE ===== */
    sheet.mergeCells("B2:G2");
    sheet.getCell("B2").value =
      "Leave Overview Report (Detailed Summary Report)";
    sheet.getCell("B2").font = { bold: true, size: 14 };
    sheet.getCell("B2").alignment = { horizontal: "center" };

    /* ===== DATE RANGE ===== */
    sheet.mergeCells("B4:G4");
    sheet.getCell("B4").value = `${moment(details.fromDate).format(
      "MMM DD YYYY",
    )}  To  ${moment(details.toDate).format("MMM DD YYYY")}`;
    sheet.getCell("B4").alignment = { horizontal: "center" };

    /* ===== COMPANY INFO ===== */
    sheet.getCell("B5").value = "Company:";
    sheet.getCell("B5").font = { bold: true };
    sheet.getCell("C5").value = "AS";

    const startCol = 1; // A
    const endCol = 7; // G

    for (let col = startCol; col <= endCol; col++) {
      sheet.getCell(5, col).border = {
        bottom: { style: "medium", color: { argb: "FF000000" } },
      };
    }

    let currentRow = 8;

    data.forEach((emp, empIndex) => {
      /* ===== EMPLOYEE INFO ===== */

      sheet.getCell(`B${currentRow}`).value = "Name:";
      sheet.getCell(`C${currentRow}`).value = emp.empName;

      sheet.getCell(`B${currentRow}`).font = { bold: true };

      sheet.getCell(`D${currentRow}`).value = "Id:";
      sheet.getCell(`E${currentRow}`).value = emp.empCode;

      sheet.getCell(`D${currentRow}`).font = { bold: true };

      sheet.getCell(`F${currentRow}`).value = "Location:";
      sheet.getCell(`G${currentRow}`).value = emp.location;

      sheet.getCell(`F${currentRow}`).font = { bold: true };

      currentRow++;

      sheet.getCell(`B${currentRow}`).value = "Joining Date:";
      sheet.getCell(`D${currentRow}`).value = emp.joiningDAte;

      sheet.getCell(`B${currentRow}`).font = { bold: true };

      sheet.mergeCells(`B${currentRow}:C${currentRow}`);

      sheet.getCell(`E${currentRow}`).value = "Confirmation Date:";
      sheet.getCell(`G${currentRow}`).value = emp.joiningDAte;

      sheet.getCell(`E${currentRow}`).font = { bold: true };

      sheet.mergeCells(`E${currentRow}:F${currentRow}`);

      currentRow++;

      sheet.getCell(`B${currentRow}`).value = "Quarterly Allocated Leaves:";
      sheet.getCell(`D${currentRow}`).value = emp.qurterlyLeaves;

      sheet.getCell(`B${currentRow}`).font = { bold: true };

      sheet.mergeCells(`B${currentRow}:C${currentRow}`);

      sheet.getCell(`E${currentRow}`).value = "Yearly Allocated Leaves:";
      sheet.getCell(`G${currentRow}`).value = emp.allocatedLeaves;

      sheet.getCell(`E${currentRow}`).font = { bold: true };

      sheet.mergeCells(`E${currentRow}:F${currentRow}`);

      currentRow++;

      // currentRow += 2;

      /* ===== TABLE HEADER ===== */
      const headerRow = sheet.addRow([
        "",
        "Sr. No.",
        "Date",
        "Leave Type",
        "Leave Category",
        "Taken Leaves",
        "Balance Leaves",
      ]);

      headerRow.eachCell((cell, colNumber) => {
        if (colNumber === 1) return; // Skip column A

        cell.font = { bold: true };
        cell.alignment = { horizontal: "left" };
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
      });

      /* ===== ATTENDANCE ROWS ===== */

      if (emp.empLeaveDay.length > 0) {
        const firstDataRow = headerRow.number + 1;
        emp.empLeaveDay.forEach((day, index) => {
          const row = sheet.addRow([
            "",
            index + 1,
            day.leaveDay,
            day.leaveType,
            day.leaveCategory,
            `Paid ${day.paidLeave} Unpaid ${day.unpaid} Goodwill ${day.goodwill}`,
            day.balanceLeave ? day.balanceLeave : "",
          ]);

          // sheet.mergeCells(`B${row.number}:G${row.number}`);

          row.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              bottom: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
            };
          });

          sheet.getCell(`N${row.number}`).alignment = {
            horizontal: "left",
            vertical: "middle",
          };
        });
        const lastDataRow = headerRow.number + emp.empLeaveDay.length;
        sheet.mergeCells(`F${firstDataRow}:F${lastDataRow}`);
        sheet.getCell(`F${firstDataRow}`).alignment = { wrapText: true };
        sheet.mergeCells(`G${firstDataRow}:G${lastDataRow}`);
      } else {
        const row = sheet.addRow(["", "No Leaves Taken", ""]);

        sheet.mergeCells(`B${row.number}:G${row.number}`);

        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
        });

        sheet.getCell(`B${row.number}`).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
      }

      /* ===== SPACE BETWEEN EMPLOYEES ===== */
      currentRow = sheet.lastRow.number + 2;
    });

    /* ===== COLUMN WIDTH ===== */
    sheet.columns = [
      { width: 2 },
      { width: 10 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 13 },
      { width: 15 },
      { width: 20 },
      { width: 15 },
    ];

    const START_COL = 2; // A
    const END_COL = 7; // G

    sheet.eachRow({ includeEmpty: true }, (row) => {
      for (let col = START_COL; col <= END_COL; col++) {
        const cell = row.getCell(col); // <-- forces cell creation

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFFFF" }, // white
        };

        // Optional: clear borders if needed
        // cell.border = {};
      }
    });

    sheet.views = [{ showGridLines: false }];

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      "LeaveOverviewReport.xlsx",
    );
  };

  return (
    <>
      <div className="dashboard-container">
        <DashboardGreeting navHeading={navHeading} user={user} />
        <div
          className={
            user.role === "1" ? "filterBarNew filterBar mb-3" : "filterBar mb-3"
          }
        >
          {user.role === "1" ? (
            <div className="d-flex">
              <div className="searchBar">
                <input
                  type="text"
                  placeholder="Search Employee name/ID"
                  value={search}
                  onChange={handleSearch}
                />
                <span>
                  <img src={SearchIcon} alt="" />
                </span>
              </div>
            </div>
          ) : null}

          <div className="sort-filter filter topbar">
            {tabIndex !== 0 && (
              <>
                <div className="new-calendar-type flex justify-content-center">
                  <Calendar
                    value={date}
                    onChange={handleDateChange}
                    view="month"
                    dateFormat="M, yy"
                    style={{ height: "100%" }}
                    showIcon
                    selectOtherMonths
                  />
                </div>
              </>
            )}

            {user.role === "1" && tabIndex === 0 ? (
              <>
                <Select
                  value={selectedReportType}
                  onChange={handleSelectChange}
                  options={reportTypes}
                  placeholder="Select Type"
                />
              </>
            ) : null}

            <div className="d-flex gap-2">
              <div className="filter" onClick={showFilter}>
                <img src={FilterIcon} alt="" />
              </div>
              <div
                className="export"
                onClick={(e) => {
                  tabIndex === 0
                    ? exportToExcel()
                    : tabIndex === 1
                      ? exportAttendanceReport()
                      : exportLeaveOverviewReport();
                }}
              >
                <span>
                  <img src={ExportIcon} alt="" />
                </span>
                <span>Export</span>
              </div>
            </div>
          </div>
        </div>

        <Tabs
          selectedIndex={tabIndex}
          onSelect={(index) => {
            setTabIndex(index);
          }}
        >
          <TabList>
            <Tab
              className={
                tabIndex === 0 ? "react-tabs__tab active" : "react-tabs__tab"
              }
            >
              Leaves Report
            </Tab>

            <Tab
              className={
                tabIndex === 1 ? "react-tabs__tab active" : "react-tabs__tab"
              }
            >
              Attandance Report
            </Tab>
            <Tab
              className={
                tabIndex === 2 ? "react-tabs__tab active" : "react-tabs__tab"
              }
            >
              Leaves Overview Report
            </Tab>
          </TabList>
          <div className="">
            <TabPanel>
              <div className="table-container" style={{ overflowX: "auto" }}>
                {selectedReportType.value === "1" ? (
                  <>
                    <QuarterlyLeavesReport
                      checked={checkedQuarters}
                      checked2={checkedCols}
                      selectedReportType={selectedReportType}
                      leavesReport={quarterlyLeavesReport}
                      filter={quarterlyLeavesReportFilter}
                      filteredData={quarterlyLeavesReportFilterData}
                      year={year}
                      loading={loading}
                    />
                  </>
                ) : (
                  <>
                    <MonthlyLeavesReport
                      checked={checked}
                      checked2={checked2}
                      date={date}
                      filter={monthlyLeavesReportFilter}
                      filteredData={monthlyLeavesReportFilterData}
                      monthlyLeavesReport={monthlyLeavesReport}
                      details={details}
                      loading={loading}
                    />
                  </>
                )}
              </div>
            </TabPanel>
            <TabPanel>
              {loading2 ? (
                <>
                  <Skeleton active={loading2} />
                </>
              ) : (filter2 ? filteredData2 : attendeces).length === 0 ? (
                <>
                  {" "}
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </>
              ) : (
                <>
                  <div className="attandanceReport">
                    <div className="table-responsive">
                      <table
                        className="table table-striped table-bordered"
                        id="myTable2"
                        border="1"
                        cellspacing="0"
                        cellpadding="8"
                        style={{
                          backgroundColor: "white",
                          fontFamily: "Arial, sans-serif",
                        }}
                      >
                        {Array.isArray(filter2 ? filteredData2 : attendeces)
                          ? (filter2 ? filteredData2 : attendeces).map(
                              (item, empIndex) => {
                                return (
                                  <>
                                    <tr>
                                      <td colSpan={3}>
                                        <strong>Emp Code:</strong>{" "}
                                        {item.empCode}
                                      </td>
                                      <td colSpan={6}>
                                        <strong>Employee Name :</strong>{" "}
                                        {item.empName}
                                      </td>
                                      <td colSpan={4}></td>
                                    </tr>
                                    <tr>
                                      <td colSpan={13}>
                                        <DataTable
                                          columns={columns}
                                          data={item.attendenceDays}
                                        />
                                      </td>
                                    </tr>

                                    {/* <tr className="header-row">
                                  <th width="100px">Att. Date</th>
                                  <th width="90">InTime</th>
                                  <th width="90">OutTime</th>
                                  <th>Shift</th>
                                  <th width="75">S.InTime</th>
                                  <th>S.OutTime</th>
                                  <th>Work Dur.</th>
                                  <th>OT</th>
                                  <th>Total Dur.</th>
                                  <th>LateBy</th>
                                  <th>EarlyGoingBy</th>
                                  <th>Location</th>
                                  <th>Platform</th>
                                  <th>Status</th>
                                  <th width="750px">Punch Records</th>
                                </tr>
                                {Array.isArray(item.attendenceDays)
                                  ? item.attendenceDays.map(
                                      (item2, dayIndex) => {
                                        return (
                                          <>
                                            <tr className="body-row">
                                              <td>
                                                {item2.logdate &&
                                                  item2.logdate.split(" ")[0]}
                                              </td>
                                              <td>{item2.inTime}</td>
                                              <td>{item2.outTime}</td>
                                              <td>{item2.shift}</td>
                                              <td>{item2.sInTime}</td>
                                              <td>{item2.sOutTime}</td>
                                              <td>{item2.workDuration}</td>
                                              <td>{item2.ot}</td>
                                              <td>
                                                {item2.totalWorkingHourse}
                                              </td>
                                              <td>{item2.lateBy}</td>
                                              <td>{item2.earlyGoingBy}</td>
                                              <td>{item2.location}</td>
                                              <td>
                                                <div
                                                  className={
                                                    item.platfrom === "1"
                                                      ? "status elms"
                                                      : item.platfrom === "2"
                                                      ? "status attendrix"
                                                      : "status"
                                                  }
                                                >
                                                  <span>
                                                    {item.platfrom === "1"
                                                      ? "ELMS"
                                                      : item.platfrom === "2"
                                                      ? "Attendrix"
                                                      : "-"}
                                                  </span>
                                                </div>
                                              </td>
                                              <td>
                                                <div
                                                  className={`${
                                                    item2.lateMarkSts === 0 &&
                                                    item2.pstatus === "Present"
                                                      ? "status present"
                                                      : item2.lateMarkSts === 1
                                                      ? "status latemark"
                                                      : item2.pstatus ===
                                                        "Holiday"
                                                      ? "status halfDay"
                                                      : item2.pstatus ===
                                                          "Absent" &&
                                                        item2.holidaysts === 0
                                                      ? "status absent"
                                                      : item2.holidaysts ===
                                                          "Weekoff" ||
                                                        item2.holidaysts === "1"
                                                      ? "status"
                                                      : "status"
                                                  }`}
                                                >
                                                  {item2.lateMarkSts === 0 &&
                                                  item2.pstatus ===
                                                    "Present" ? (
                                                    <>
                                                      <span
                                                        title={item2.pstatus}
                                                      >
                                                        {item2.pstatus}
                                                      </span>
                                                    </>
                                                  ) : item2.lateMarkSts ===
                                                    1 ? (
                                                    <span title="Late Mark">
                                                      Late Mark
                                                    </span>
                                                  ) : item2.holidaysts ===
                                                      "Weekoff" ||
                                                    item2.holidaysts === 1 ? (
                                                    <>
                                                      <span title="Week Off">
                                                        Week Off
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <span
                                                        title={item2.pstatus}
                                                      >
                                                        {item2.pstatus}
                                                      </span>
                                                    </>
                                                  )}
                                                </div>
                                              </td>
                                              <td>{item2.punchRecord}</td>
                                            </tr>
                                            <tr></tr>
                                          </>
                                        );
                                      }
                                    )
                                  : null} */}
                                    <tr
                                      style={{
                                        backgroundColor: "white",
                                      }}
                                    >
                                      <td colSpan={10}>
                                        <strong>
                                          Total Duration= {item.totalDur},
                                          PresentDays= {item.presentDays},
                                          Leaves= {item.leaveDays}, Holiday={" "}
                                          {item.holidaystsCount}, AbsentDays={" "}
                                          {item.absentDaysCount} , Weekly Off={" "}
                                          {item.weekoffCount}
                                        </strong>
                                      </td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td
                                        colSpan={14}
                                        style={{ backgroundColor: "white" }}
                                      >
                                        &nbsp;
                                      </td>
                                    </tr>
                                  </>
                                );
                              },
                            )
                          : null}
                      </table>
                    </div>
                  </div>
                </>
              )}
            </TabPanel>
            <TabPanel>
              <LeaveOverviewReport
                details={details}
                leaveOverviewData={leaveOverviewData}
                filter={filter}
                filteredData={filteredData}
                setLeaveOverviewData={setLeaveOverviewData}
                loading={loading}
              />
            </TabPanel>
          </div>
        </Tabs>

        <div
          className={`${filterBy ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setFilterBy(false);
          }}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <ReportsFilterModal
              user={user}
              details={details}
              setDetails={setDetails}
              tabIndex={tabIndex}
              checked={checked}
              handleCheckedChange={handleCheckedChange}
              handleFilter={handleFilter}
              clearFilter={clearFilter}
              fromDate={fromDate}
              setFromDate={setFromDate}
              toDate={toDate}
              setToDate={setToDate}
              selectedQuarter={selectedQuarter}
              setSelectedQuarter={setSelectedQuarter}
              lists={lists}
              checked2={checked2}
              handleCheckedChange2={handleCheckedChange2}
              selectedReportType={selectedReportType}
              year={year}
              setYear={setYear}
            />
          </div>
        </div>

        <div
          className={`${showDelete ? "modal-overlay" : ""}`}
          onClick={(e) => {
            setShowDelete(false);
          }}
        >
          <div className="" onClick={(e) => e.stopPropagation()}>
            <Delete
              heading="Are you sure you want to delete this leave type"
              para="Deleting this leave type will remove all its details."
              showDelete={showDelete}
              setShowDelete={setShowDelete}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Reports;
